import React from 'react';
const Popover = (props) => {
    const style = { 'minWidth': props.width ?? undefined, 'positionAnchor': props.anchorName ?? undefined };
    if (props.show) {
        return <div className={(props.className ? 'popover ' + props.className + ' ' : 'popover ') + props.position} style={style}>{props.children}</div>
    } else {
        return null;
    }
}

export default Popover;
